export default "__VITE_ASSET__BOBf9WYX__"